import { Pagination } from 'antd';
import * as React from 'react';
import style from './index.module.scss';
import classnames from 'classnames';
import zhCN from './locale/index';
let SiriusPagination = (props) => {
    return React.createElement(Pagination, Object.assign({}, props, { locale: zhCN, className: classnames([style.siriusPagination, props.className]) }));
};
export default SiriusPagination;
